import { Box, type BoxStyles } from '../../../../mads';
import { useI18n } from '../../../../shared/I18n';

import { StyleSheet, type StyleProp, type ViewStyle } from 'react-native';

export type ActionButtonsWrapperProps = {
    sx?: BoxStyles | StyleProp<ViewStyle>;
    children: React.ReactNode;
    loggedIn: boolean;
    jobTitle?: string;
};

export function ActionButtonsWrapper({
    sx,
    children,
    loggedIn,
    jobTitle,
}: ActionButtonsWrapperProps) {
    const i18n = useI18n();

    if (!loggedIn) {
        return null;
    }

    return (
        <Box
            accessibilityRole="toolbar"
            accessibilityLabel={
                jobTitle
                    ? i18n.gettext('Job actions for {0}', [jobTitle])
                    : i18n.gettext('Job actions')
            }
            sx={[styles.actionButtons, sx] as BoxStyles}
        >
            {children}
        </Box>
    );
}

const styles = StyleSheet.create({
    actionButtons: {},
});
